/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, MouseEvent } from 'react'

import type Swing from './types/Swing'

type PlayerListProps = {
    handleRemove: (info: Swing) => void
    handleReset: () => void
    info: Swing
    onSelect: (info: Swing) => void
    proportionPlayed: number
    selected: boolean
}

const imageSize = 60
const PlayerCard = memo(
    ({
        handleRemove,
        handleReset,
        info,
        onSelect,
        selected,
        proportionPlayed,
    }: PlayerListProps) => {
        const scale = selected ? `scaleX(${proportionPlayed})` : 'scaleX(0)'
        const extraClass = selected ? ' video-viz-player-card-selected' : ''

        function removeHandler(e: MouseEvent, swing: Swing) {
            // Don't want to bubble to 'onSelect'
            e.stopPropagation()
            handleRemove(swing)
        }

        function resetHandler(e: MouseEvent) {
            // Don't want to bubble to 'onSelect'
            e.stopPropagation()
            handleReset()
        }

        return (
            <div
                key={info.id}
                onClick={() => onSelect(info)}
                className={`video-viz-player-card video-viz-border${extraClass}`}
            >
                <div
                    className="video-viz-remove-swing"
                    onClick={(e) => removeHandler(e, info)}
                >
                    ✖
                </div>
                {selected && (
                    <div // eslint-disable
                        className="video-viz-reset-swing"
                        onClick={(e) => resetHandler(e)}
                    >
                        ⏪︎
                    </div>
                )}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '5px',
                        background: '#399098',

                        transformOrigin: 'left',
                        transform: scale,
                    }}
                />
                <div
                    style={{
                        fontSize: '16px',
                        height: '25px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        marginTop: '4px',
                        padding: '0 3px',
                    }}
                >
                    {info.lastName}
                </div>
                <div style={{ position: 'relative' }}>
                    {/* <div className="video-viz-play-button">︎▶︎</div> */}
                    <img
                        alt={`${info.name}`}
                        src={`https://midfield.mlbstatic.com/v1/people/${
                            info.playerId
                        }/mlb/${imageSize * 3}?circle=true`}
                        height={imageSize * 1.5}
                        width={imageSize * 1.5}
                    />
                </div>
                <div style={{ marginBottom: '5px' }}>
                    {info.year} - {info.batSide === 'L' ? 'Left' : 'Right'}{' '}
                </div>
            </div>
        )
    }
)

PlayerCard.displayName = 'PlayerCard'

export default PlayerCard
